import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";

interface LegendItemProps {
  label: string;
  swatchClassName: string;
}

const LegendItem = ({ label, swatchClassName }: LegendItemProps) => {
  return (
    <div className="flex flex-row items-center gap-2">
      <div className={`size-5 rounded-md ${swatchClassName}`} />
      <Label>{label}</Label>
    </div>
  );
};

export const Legend = () => {
  return (
    <Card>
      <CardContent className="flex flex-col gap-1">
        <p className="font-bold">Legend</p>
        <LegendItem label="Not Flooded" swatchClassName="bg-[#06D6A0]" />
        <LegendItem
          label="Building Flooded"
          swatchClassName="bg-linear-to-r from-[#FFD166] to-[#EF476F]"
        />
        <LegendItem
          label="Parcel Flooded"
          swatchClassName="bg-linear-to-r from-[#5CDCEB] to-[#178FC2]"
        />
      </CardContent>
    </Card>
  );
};
